window.searchModal = window.searchModal || {
  init() {
    this.bindListeners();
  },

  open() {
    document.querySelector(".search-drawer")?.classList.add("search-drawer--active");
  },

  close() {
    document.querySelector(".search-drawer")?.classList.remove("search-drawer--active");
  },

  bindListeners() {
    // OPEN
    document.querySelector(".header-searchButton")?.addEventListener("click", () => {
      const drawer = document.querySelector(".search-drawer");
      if (drawer?.classList.contains("search-drawer--active")) {
        this.close();
      } else {
        this.open();
      }
    });

    // CLOSE
    document.querySelector(".search-closeButton")?.addEventListener("click", () => {
      this.close();
    });

    // CLICK OVERLAY TO CLOSE
    document.querySelector(".search-drawer")?.addEventListener("click", () => {
      this.close();
    });

    document.querySelector(".search-drawer-box")?.addEventListener("click", (e) => {
      e.stopPropagation();
    });
  },
};

window.searchModal.init();
